import { render, staticRenderFns } from "./ModalConfirmTransferData.vue?vue&type=template&id=49a7023a&scoped=true"
import script from "./ModalConfirmTransferData.vue?vue&type=script&lang=js"
export * from "./ModalConfirmTransferData.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmTransferData.vue?vue&type=style&index=0&id=49a7023a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a7023a",
  null
  
)

export default component.exports